
import { Component, OnInit, Inject, Input, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationStart, RouterLink, RouterLinkActive } from '@angular/router';
import { environment } from 'src/environments/environment';
// Services
import { AuthenticationService } from 'src/app/services/auth/authentication.service';
import { SharedService } from '../../services/api/message.service';

// models
import { SchoolData } from 'src/app/models/schoolUser';
import { CommonService } from 'src/app/services/api/common.service';
import { Subscription } from 'rxjs';
import Intercom from '@intercom/messenger-js-sdk';
import { MixpanelService } from 'src/app/mixpanel.service';
import { SwichBackToPythonComponent } from '../swich-back-to-python/swich-back-to-python.component';
import { NgClass, NgIf } from '@angular/common';
import { CommonAnnouncementComponent } from 'src/app/pages/common/common-announcement/common-announcement.component';
import { BrazeService } from 'src/app/braze.service';
import { ProfileService } from 'src/app/services/api/consumer/profile.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DirectivesModule } from 'src/app/directives.module';
import { co } from '@fullcalendar/core/internal-common';
declare var Canny: any; // Add this at the top of your TS file
declare var $: any;
import { distinctUntilChanged } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-consumer-header',
  templateUrl: './consumer-header.component.html',
  styleUrls: ['./consumer-header.component.scss'],
  standalone: true,
  imports: [NgClass, NgIf, RouterLink, RouterLinkActive, DirectivesModule, CommonAnnouncementComponent],
})
export class ConsumerHeaderComponent implements OnInit {
  /**
   * Returns true if the user's created_at date is after 7 May 2026.
   */
  get showSwitchBack(): boolean {
    const createdAtStr = this.schoolProps?.properties?.user_access_data?.created_at;
    if (!createdAtStr) return false;
    // createdAtStr is in format "DD/MM/YYYY"
    const [day, month, year] = createdAtStr.split('/').map(Number);
    if (!day || !month || !year) return false;
    const createdAt = new Date(year, month - 1, day);
    // 7 May 2026
    const cutoff = new Date(2026, 4, 7);
    return createdAt > cutoff;
  }
  @Input() announcementData = '';
  public schoolProps!: SchoolData;
  schoolLogo: any;
  activeSchoolDropdown = false;
  bookingsStatus: boolean = true;
  offcanvasOpen: boolean = false;
  sub!: Subscription;
  jobsUrl!: string;
  from_page_cookie: any;
  teacherName: any;
  jobSchoolUrl: boolean = false;

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private brazeService: BrazeService,
    private ProfileService: ProfileService,
    private ngxService: NgxUiLoaderService,
    private sharedService: SharedService,
    private cdRef: ChangeDetectorRef,
    private commonService: CommonService,
    private http: HttpClient
  ) { }

  ngOnInit(): void {
    this.schoolProps = JSON.parse(localStorage.getItem("userData") || '{}');
    $('head').append(
      '<div data-tf-live="01KP7T4APB1R623DC0FH4076K3"></div><script src="//embed.typeform.com/next/embed.js"></script>'
    );

    Canny('initChangelog', {
      appID: '68de4a8304887f1960a022d7',
      labelIDs: ['696f1c2b0f343ed4ebeb7351'], // Teacher

      position: 'bottom',
      align: 'right',
      theme: 'light', // options: light [default], dark, auto
    });
    Canny('renderChangelog', {
      labelIDs: ['696f1c2b0f343ed4ebeb7351'], // Teacher
      theme: 'light'
    });
    this.intercomValues();

    this.schoolLogo = this.schoolProps.properties.profile_image;
    this.bookingsStatus = this.schoolProps.properties.using_cc_to_B;
    this.from_page_cookie =
      document.cookie.match('(^|;)\\s*' + 'from' + '\\s*=\\s*([^;]+)')?.pop() ||
      '';
    this.brazeService.initializeBraze(this.schoolProps);
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.checkSchoolDropdownActive(event.url);
      }
    });
    this.checkSchoolDropdownActive(this.router.url);
    // this.ProfileService.bookingsStatus$
    //   .pipe(distinctUntilChanged())
    //   .subscribe(status => {
    //     setTimeout(() => {
    //       this.bookingsStatus = status;
    //     }, 1000);
    //   });
  }
  get isAuthenticated(): boolean {
    return this.authService.isLoggedIn();
  }
  intercomValues() {
    Intercom({
      app_id: this.schoolProps.properties.user_access_data.app_id.toString(),
      region: 'ap',
      apiBase: 'https://api.au.intercom.io',
      name: this.schoolProps.properties.full_name,
      user_id: this.schoolProps.properties.user_access_data.user_id.toString(),
      user_hash: this.schoolProps.properties.user_access_data.user_hash,
      is_qld_doe_relief_teacher: Boolean(
        this.schoolProps.properties.is_qld_doe_relief_teacher ??
        this.schoolProps.properties.is_qld_teacher ??
        false
      ),
      is_qld_user: Boolean(this.schoolProps.properties.is_qld_user ?? false),
      is_qld_doe_user: Boolean(this.schoolProps.properties.is_qld_user ?? false),
      "is qld_doe_user": Boolean(this.schoolProps.properties.is_qld_user ?? false),
      is_qld_doe_school_user: Boolean(this.schoolProps.properties.is_qld_school ?? false),
    } as any);
  }
  checkSchoolDropdownActive(url: string) {
    this.activeSchoolDropdown = [
      '/teacher/my-schools',
      '/teacher/find-new-schools',
      '/teacher/my-school-invites'
    ].some(path => url.startsWith(path));
  }

  logout() {
    this.ngxService.start();
    if (localStorage.getItem('bookingSchool') == "true") {
      this.authService.loggedOut();
      if (this.router) {
        this.router.ngOnDestroy();
      }
    } else {
      this.authService.loggedOut();
      if (this.router) {
        this.router.ngOnDestroy();
      }
    }
  }
  navigateToDashboard() {
    this.router.navigate(['/teacher/dashboard']);
  }

  closeOffcanvasOnNav() {
    this.offcanvasOpen = false;
  }
  ngAfterViewInit() {
    Canny('renderChangelog', {
      labelIDs: ['696f1c2b0f343ed4ebeb7351'], // Teacher
      theme: 'light'
    });
    setTimeout(() => {
      this.sub = this.sharedService.teacher_logo.subscribe((data) => {
        this.schoolLogo = data;
        const userData = JSON.parse(localStorage.getItem("userData") || '{}');
        if (userData && userData.properties) {
          userData.properties.profile_image = data;
          localStorage.setItem("userData", JSON.stringify(userData));
        }
        this.cdRef.detectChanges();
      });
      // Set initial teacherName from localStorage
      this.teacherName = localStorage.getItem('full_name');
      // Subscribe to teacher_name changes for live updates
      this.sharedService.teacher_name?.subscribe((data: string) => {
        this.teacherName = data;
        localStorage.setItem('full_name', data);
        this.cdRef.detectChanges();
      });
      this.bookingsStatus = this.schoolProps.properties.using_cc_to_B;
      // Removed duplicate bookingsStatus$ subscription to avoid multiple updates on reload
    });

  }
  someAsyncCallback() {
    this.ProfileService.bookingsStatus$.subscribe(status => {
      setTimeout(() => {
        this.bookingsStatus = status;
      }, 1000);
      this.cdRef.detectChanges();
    });
  }
  openChangelog() {
    Canny('renderChangelog', {
      labelIds: ['696f1c2b0f343ed4ebeb7351'], // Teacher
      theme: 'light'
    });
  }
  redirectToJobsUrl() {
    if (!this.schoolProps.properties.is_qld_teacher) {
      // Redirect to jobs-test or jobs based on hostname
      if (window.location.hostname === 'booking-test.classcover.com.au') {
        window.open("https://jobs-test.classcover.com.au/", '_blank');
      } else if (window.location.hostname === 'booking.classcover.com.au') {
        window.open("https://jobs.classcover.com.au/", '_blank');
      } else {
        this.router.navigate(['/teacher/jobs']);
      }
    } else {
      this.router.navigate(['/teacher/jobs']);
    }
  }
  redirectToTeacherJobsUrl() {
    // Redirect to jobs-test or jobs based on hostname
    if (window.location.hostname === 'booking-test.classcover.com.au') {
      window.open("https://jobs-test.classcover.com.au/", '_blank');

    } else if (window.location.hostname === 'booking.classcover.com.au') {
      window.open("https://jobs.classcover.com.au/", '_blank');
    } else {
      this.jobsUrl = 'http://localhost:4200/';
    }
  }
  backToAdmin() {
    this.authService.loggedOut();
    // if (this.router) {
    //   this.router.ngOnDestroy();
    // }
    window.open(environment.backToAdmin, '_self');
  }
  openClassCover() {
    this.ngxService.start();
    this.commonService.learnworldLogin().subscribe({
      next: (res: any) => {
        // console.log(res);
        if (res.status) {
          window.open(res.response.url, '_self');
        } else {
          this.ngxService.stop();
        }
      },
      error: (err: any) => {
        console.log(err);
        this.ngxService.stop();
      }
    });
  }
  switchBack() {
    this.ngxService.start();
    // let userId = this.schoolProps.properties.user_access_data.created_at;
    // window.location.replace(environment.apiUrl + 'en/back_to_cc/' + userId);
    // setTimeout(() => {
    //   this.authService.loggedOut();
    //   if (this._router) {
    //     this._router.ngOnDestroy();
    //   }
    // }, 1200);

    const body: any = { tryAngular: false };
    this.http.post(
      environment.apiUrl + 'api/v1/teacher/back-to-cc/',
      body,
      { withCredentials: true }
    ).subscribe(response => {
      window.location.href = environment.apiUrl;
    });
    localStorage.clear();
    sessionStorage.clear();
    this.router.ngOnDestroy();
    document.cookie =
      'refresh_token=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'access_token=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'userRole=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'from=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    document.cookie =
      'bookings_on_off=; path=/; domain=.' +
      environment.cookiesDomain +
      '; expires=' +
      new Date(0).toUTCString();
    // this.commonService.switchBackToPythonTeacher().subscribe({
    //   next: (res: any) => {
    //     if (res) {
    //       // this.authService.loggedOut();
    //       // if (this._router) {
    //       //   this._router.ngOnDestroy();
    //       // }
    //       setTimeout(() => {
    //         window.location.replace(environment.apiUrl);
    //       }, 1200);

    //     } else {
    //       this.ngxService.stop();
    //       this.toastr.error('Error switching back to old ClassCover. Please try again.');
    //       console.log('error in the response', res);
    //     }
    //   },
    //   error: (err: any) => {
    //     console.log(err);
    //     this.toastr.error('Error switching back to old ClassCover. Please try again.');
    //     this.ngxService.stop();
    //   },
    // });
  }
}
